import React from 'react'

import AuthorInstruction from '../components/other/authorInstruction';
import RightSide from '../components/common/rightSide';

const AuthorInstructionPage = () => {
    return (
        <>
            <div className="container-fluid mt-2">
                <div className='row'>
                {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <AuthorInstruction />
                    </div>
                   
                </div>
            </div>

        </>
    )
}

export default AuthorInstructionPage;